module.exports = __webpack_public_path__ + "static/media/videoKarya.da45f716.mp4";